import jsPDF from "jspdf";
import { logoBase64 } from "../../../public/assets/logoBase64";
import { VolantePagoResponse } from "../paginas/comisiones/components/volante-pago/volante-pago.component";
import { PayStubResponse } from "../interfaces/comisiones.interface";

interface params {
  data: VolantePagoResponse[],
  usuario: string,
  fechaCorte: Date;
  tipoCorte: string;
}

export const exportarVolantePago = ({ data, usuario, fechaCorte, tipoCorte }: params) => {
  const doc = new jsPDF({ orientation: "landscape" }) as any; // Orientación landscape
  const pageHeight = doc.internal.pageSize.height;
  const mappedData = mapData(data);

  const producerName = data[0].producerName;
  const producerCode = data[0].producerCode;
  const producerType = data[0].producerType;
  const paymentType = data[0].paymentType;
  const licenceNumber = data[0].licenceNumber;
  const bank = data[0].bank;
  const licenceExpiration = data[0].licenceExpiration;
  const accountType = data[0].accountType;
  const phoneNumber = data[0].phoneNumber;
  const accountNumber = data[0].accountNumber;
  const emailAddress = data[0].emailAddress;
  const address = data[0].address;



  const formattedFechaCorte: string = fechaCorte.toLocaleDateString('es-ES', {
    month: 'long',
    year: 'numeric'
  })

  let currentY = 15; // Posición inicial en la página

  // Header de la página

  const pageHeader = (doc: any) => {
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 13);
    doc.setFontSize(14);
    doc.text(`Volante de pago - Portal Intermediario`, 55, 15);
    doc.text(`${usuario}`, 55, 20);

    doc.setFontSize(12);
    doc.text(`Período: ${formattedFechaCorte} - ${tipoCorte}`, 15, 30);
    currentY += 11;
  }

  doc.autoTable({
    didDrawPage: () => pageHeader(doc),
  });

  const producerData = [
    ['Productor', `${producerCode}`, producerName,],
  ]
  currentY += 7
  doc.autoTable({
    startY: currentY,
    body: producerData,
    columnStyles: {
      0: { cellWidth: 35 }, // Width for the first column
      1: { cellWidth: 35 }, // Width for the second column
      2: { cellWidth: 'auto' }, // Automatic width for the third column
    },
    margin: { left: 10 },
    didParseCell: (data: any) => {
      // Aplica estilos solo a la primera fila del body
      if (data.row.index === 0 && data.section === 'body') {
        data.cell.styles.valign = 'bottom'; // Grosor del borde
        data.cell.styles.lineWidth = 0; // Grosor del borde
        data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
        data.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
        data.cell.styles.fillColor = [222, 222, 222]; // Fondo gris claro opcional
        data.cell.styles.textColor = [80, 80, 80]; // Texto gris oscuro
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        data.cell.styles.fontSize = 10; // Texto en negrita
      }
      if (data.column.index === 0 && data.section === 'body') {
        data.cell.styles.textColor = [0, 85, 140]; // Texto azul oscuro
      }
    }
  });

  const generalData = [
    ['Datos generales', "", "", "", ""],
    ['Tipo producto:', `${producerType}`, "", "Forma pago: ", `${paymentType}`],
    ['Licencia:', `${licenceNumber}`, "", "Banco: ", `${bank}`],
    ['Vencimiento licencia:', `${licenceExpiration}`, "", "Tipo cuenta: ", `${accountType}`],
    ['Teléfono:', `${phoneNumber}`, "", "Número cuenta: ", `${accountNumber}`],
    ['Correo:', `${emailAddress}`, "", "", ""],
    ['Dirección:', `${address}`, "", "", ""],
  ]
  currentY = doc.lastAutoTable.finalY + 2;
  doc.autoTable({
    startY: currentY,
    body: generalData,
    columnStyles: {
      0: { cellWidth: 45 }, // Width for the first column
      1: { cellWidth: 80 }, // Width for the second column
      2: { cellWidth: 10 }, // Automatic width for the third column
      3: { cellWidth: 35 }, // Automatic width for the third column
      4: { cellWidth: 'auto' }, // Automatic width for the third column
    },
    margin: { left: 10 },
    didParseCell: (data: any) => {
      // Aplica estilos solo a la primera fila del body
      if (data.row.index === 0 && data.section === 'body') {
        // row.cell.styles.fillColor = [0, 85, 140]; // Color de fondo azul
        data.cell.styles.fillColor = [222, 222, 222]; // Fondo gris claro opcional
        data.cell.styles.textColor = [80, 80, 80]; // Texto gris oscuro
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        data.cell.styles.fontSize = 10; // Texto en negrita
      }
      if (data.row.index !== 0 && data.section === 'body') {
        data.cell.styles.fillColor = [255, 255, 255]; // Fondo gris claro opcional
        data.cell.styles.textColor = [0, 0, 0]; // Texto gris oscuro
        data.cell.styles.fontSize = 10; // Texto en negrita
      }
      if ((data.column.index === 0 || data.column.index === 3) && data.section === 'body') {
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
      }
      if ((data.column.index === 0 && data.row.index == 0) && data.section === 'body') {
        data.cell.styles.textColor = [0, 85, 140]; // Texto azul oscuro
      }
    },
  })

  const recordsData = [
    ['Resumen pago', "", ""],
  ]
  currentY = doc.lastAutoTable.finalY + 5;
  doc.autoTable({
    startY: currentY,
    body: recordsData,
    columnStyles: {
      0: { cellWidth: 35 }, // Width for the first column
      1: { cellWidth: 'auto' }, // Width for the second column
      2: { cellWidth: 'auto' }, // Automatic width for the third column
    },
    margin: { left: 10 },
    didParseCell: (data: any) => {
      // Aplica estilos solo a la primera fila del body
      if (data.row.index === 0 && data.section === 'body') {
        // row.cell.styles.fillColor = [0, 85, 140]; // Color de fondo azul
        data.cell.styles.valign = 'bottom'; // Grosor del borde
        data.cell.styles.lineWidth = 0; // Grosor del borde
        data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
        data.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
        data.cell.styles.fillColor = [222, 222, 222]; // Fondo gris claro opcional
        data.cell.styles.textColor = [80, 80, 80]; // Texto gris oscuro
        data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        data.cell.styles.fontSize = 10; // Texto en negrita
      }
      if (data.column.index === 0 && data.section === 'body') {
        data.cell.styles.textColor = [0, 85, 140]; // Texto azul oscuro
      }
    }
  });


  Object.keys(mappedData['currencyRecords']).forEach((currency, idx) => {
    const topMargin = idx ? 15 : 2
    currentY = doc.lastAutoTable.finalY + topMargin;

    if (currentY + 65 > pageHeight) {
      doc.addPage();
      doc.autoTable({
        didDrawPage: () => pageHeader(doc),
      });
      currentY = 35;
    }
    const totalCurrency = mappedData.totalByCurrency[currency];
    const resumenData = [
      ["", "", "Transacción", "", "", "Valor"],
      ["Moneda: ", `${currency}`, "", "", "", ""],
    ]
    const records = mappedData['currencyRecords'][currency].map(r => ["", "", `${r.agrupamiento}`, "", "", `${ new Intl.NumberFormat("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(r.monto)}`]);

    resumenData.push(...records, ["", "", `Total ${currency}>>>>>`, "", "", `${ new Intl.NumberFormat("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(totalCurrency)}`]);

    doc.autoTable({
      startY: currentY,
      body: resumenData,
      columnStyles: {
        0: { cellWidth: 18 }, // Width for the first column
        1: { cellWidth: 75 }, // Width for the second column
        2: { cellWidth: 145 }, // Automatic width for the third column
      },
      margin: { left: 10 },
      didParseCell: (data: any) => {
        // Aplica estilos solo a la primera fila del body
        data.cell.styles.fillColor = [255, 255, 255]; // Fondo gris claro opcional
        data.cell.styles.textColor = [0, 0, 0]; // Texto negro

        if (data.row.index === 0 && data.section === 'body' && data.column.index > 1) {
          data.cell.styles.lineWidth = 0; // Grosor del borde
          data.cell.styles.lineWidth = { bottom: 1 }; // Grosor del borde
          data.cell.styles.lineColor = [255, 165, 0]; // Borde naranja (RGB)
          data.cell.styles.fontStyle = 'bold'; // Texto en negrita
          data.cell.styles.fontSize = 10; // Tamaño de texto
        }
        if (data.row.index === data.table.body.length - 1 && data.section === "body" && data.column.index > 1) {
          data.cell.styles.lineWidth = 0; // Grosor del borde
          data.cell.styles.lineWidth = { bottom: .5, top: .5 }; // Grosor del borde
          data.cell.styles.lineColor = [0, 175, 255]; // Borde azul (RGB)
          data.cell.styles.fontStyle = 'bold'; // Texto en negrita
          data.cell.styles.fontSize = 10; // Tamaño de texto
        }
        if (data.column.index === 0 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold'; // Texto en negrita
        }
      }
    })

  })
  doc.save(`Volante pago.pdf`);
}


interface mappedData {
  currencyRecords: Record<string, { agrupamiento: string, monto: number }[]>
  totalByCurrency: Record<string, number>
}

const mapData = (data: PayStubResponse[]): mappedData => {
  const currencyRecords: Record<string, { agrupamiento: string, monto: number }[]> = {};
  let totalByCurrency: Record<string, number> = {};

  for (let record of data) {
    if (!currencyRecords[record.currency]) { // Si el tipo de moneda aún no se encuentra en la lista
      currencyRecords[record.currency] = [{ agrupamiento: record.grouping, monto: record.ammount }]
      totalByCurrency = { ...totalByCurrency, [record.currency]: record.ammount } // Se incremente el monto para el total del tipo de moneda

    } else { // Si el tipo de moneda se encuentra en la lista
      currencyRecords[record.currency].push({ agrupamiento: record.grouping, monto: record.ammount })
      totalByCurrency[record.currency] = totalByCurrency[record.currency] + record.ammount // Se incremente el monto para el total del tipo de moneda
    }
  }
  return { currencyRecords, totalByCurrency };
}
